import {
  DateTime
} from "./chunk.JAWPSPJ3.js";
import {
  IMask
} from "./chunk.7I2462UJ.js";

// src/components/date-picker/date-picker.mask.ts
function createDatePickerMaskOptions(pattern, min, max) {
  var _a, _b, _c, _d, _e, _f;
  const options = {
    mask: Date,
    pattern,
    lazy: true,
    min,
    max,
    autofix: "pad",
    format: function(date) {
      return DateTime.fromJSDate(date).toFormat(pattern);
    },
    parse: function(str) {
      return DateTime.fromFormat(str, pattern).toJSDate();
    },
    blocks: {
      yyyy: {
        mask: IMask.MaskedRange,
        from: (_a = min == null ? void 0 : min.getFullYear()) != null ? _a : 1,
        to: (_b = max == null ? void 0 : max.getFullYear()) != null ? _b : 9999
      },
      yy: {
        mask: IMask.MaskedRange,
        from: (_c = min == null ? void 0 : min.getFullYear()) != null ? _c : 1,
        to: (_d = max == null ? void 0 : max.getFullYear()) != null ? _d : 99
      },
      y: {
        mask: IMask.MaskedRange,
        from: (_e = min == null ? void 0 : min.getFullYear()) != null ? _e : 1,
        to: (_f = max == null ? void 0 : max.getFullYear()) != null ? _f : 9999
      },
      MM: {
        mask: IMask.MaskedRange,
        from: 1,
        to: 12
      },
      M: {
        mask: IMask.MaskedRange,
        from: 1,
        to: 12
      },
      dd: {
        mask: IMask.MaskedRange,
        from: 1,
        to: 31
      },
      d: {
        mask: IMask.MaskedRange,
        from: 1,
        to: 31
      }
    }
  };
  return options;
}

export {
  createDatePickerMaskOptions
};
